import { render, staticRenderFns } from "./GalleryType1.vue?vue&type=template&id=4175e1ad"
import script from "./GalleryType1.vue?vue&type=script&lang=js"
export * from "./GalleryType1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4175e1ad')) {
      api.createRecord('4175e1ad', component.options)
    } else {
      api.reload('4175e1ad', component.options)
    }
    module.hot.accept("./GalleryType1.vue?vue&type=template&id=4175e1ad", function () {
      api.rerender('4175e1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryType1.vue"
export default component.exports